const axios = require('axios')
const moment = require('moment')
import Utils from '../../utils/Utils'
import { normalizeHbSelection } from '../../utils/channelFilter'
const Sentry = require('@sentry/vue')
const PANEL_URL = process.env.VUE_APP_API_PANEL;
const AllchatbotsLang = {
  'pt-BR': 'Todas',
  'en-US': 'All',
  'es-ES': 'Todo'
}
const internalchatbotsLang = {
  'pt-BR': 'Interno',
  'en-US': 'Internal',
  'es-ES': 'Interno'
}

export const setUserInfo = (state, info) => {
  state.userInfo = info
}
export const setUser = (state, info) => {
  state.user = info
  try {
    if (info && info._id) {
      Sentry.setUser({
        id: info._id,
        email: info.e,
        username: info.n,
        accountId: info.ci,
      })
    } else {
      Sentry.setUser(null)
    }
  } catch (e) {
    // sentry pode não estar inicializado em dev
    console.error('error setUser mutation: ', e)
  }
}
export const setUserTutorial = (state, tutorial) => {
  state.user.tutorial[tutorial] = true
}
export const setAccount = (state, info) => {
  state.account = info
  try {
    if (info && info._id) {
      Sentry.setTag('accountId', info._id)
    } else {
      Sentry.setTag('accountId', null)
    }
  } catch (e) {
    // sentry pode não estar inicializado em dev
  }
}
export const setLiveSettings = (state, payload) => {
  if (payload.away) {
    state.liveSettings.away = payload.away
    if (payload.away.options && payload.away.options.length > 0) {
      payload.away.options.forEach((each, eachIndex) => {
        state.liveSettings.away.options[eachIndex].value = each._id
      })
    }
  }
  if (payload.awayAuto) state.liveSettings.awayAuto = payload.awayAuto
  if (payload.initiations) state.liveSettings.initiations = payload.initiations
  if (payload.messages) state.liveSettings.messages = payload.messages
  /// toggle "Enviar ao cliente" por tipo de mensagem automática (ADR 0007); ausente = tudo habilitado
  if (payload.messagesDelivery) state.liveSettings.messagesDelivery = payload.messagesDelivery
  if (payload.archive) state.liveSettings.archive = payload.archive
  if (payload.exhibitions) state.liveSettings.exhibitions = payload.exhibitions
  if (payload.finishOption) state.liveSettings.finishOption = payload.finishOption
}
export const setLiveAttendantSettings = (state, payload) => {
  if (payload.hasOwnProperty('attendantBell')) state.liveAttendantSettings.attendantBell = payload.attendantBell
  if (payload.hasOwnProperty('messageBell')) state.liveAttendantSettings.messageBell = payload.messageBell
  if (payload.hasOwnProperty('sortType')) state.liveAttendantSettings.sortType = payload.sortType
  if (payload.hasOwnProperty('exhibition')) state.liveAttendantSettings.exhibition = payload.exhibition
  if (payload.hasOwnProperty('exhibitionType')) state.liveAttendantSettings.exhibitionType = payload.exhibitionType
  if (payload.hasOwnProperty('exhibitionAlertTime')) state.liveAttendantSettings.exhibitionAlertTime = payload.exhibitionAlertTime
  if (payload.hasOwnProperty('lastDepartmentId')) state.liveAttendantSettings.lastDepartmentId = payload.lastDepartmentId
}
export const setZion = (state, payload) => {
  if (payload.hasOwnProperty('status')) state.zion.status = payload.status
}
export const setLiveDepartments = (state, payload) => {
  // clear
  state.liveDepartment = {}
  state.liveDepartments = []
  state.liveDepartmentsOptions = []
  // begin
  state.liveDepartments = payload
  payload.forEach(each => {
    state.liveDepartment[each._id] = each
    let obj = { label: each.label, value: each._id, businessHours: false }
    if (each.businessHoursId && each.businessHoursId !== '' && each.businessHoursId !== 'none') {
      obj.businessHours = true
    }
    state.liveDepartmentsOptions.push(obj)
  })
}
export const setAccountCredits = (state, credits) => {
  state.credits = credits
}
export const updateAccountCredits = (state, { where, qtd }) => {
  state.account.credits[where] += qtd
}
export const setBotsDeleted = (state, bots) => {
  state.botsDeleted = bots
}
export const setBots = (state, bots) => {
  state.bots = bots
}
export const setBotGroups = (state, groups) => {
  state.botGroups = groups
}
export const setSelectedBotGroupId = (state, id) => {
  state.selectedBotGroupId = id
}
export const setBotsName = (state, botsName) => {
  state.botsName = botsName
}
export const setBotsId = (state, botsId) => {
  state.botsId = botsId
}
export const setBotsRaw = (state, botsRaw) => {
  state.botsRaw = botsRaw
}
export const setBotsById = (state, botsById) => {
  state.botsById = botsById
}
export const setBotsSelectable = (state, botsSelectable) => {
  state.botsSelectable = botsSelectable
}
export const setBot = (state, bot) => {
  state.bot = bot
}

export const setBotWhatsappIntegration = (state, { botId, tk, whatsapp } = {}) => {
  if (!botId || !whatsapp) return

  const targets = [
    state.bot && state.bot._id === botId ? state.bot : null,
    state.botsById ? state.botsById[botId] : null,
    tk && state.botsRaw ? state.botsRaw[tk] : null,
    Array.isArray(state.bots) ? state.bots.find(each => each && each._id === botId) : null
  ]

  targets.forEach(target => {
    if (!target) return
    if (!target.integrations) target.integrations = {}
    target.integrations.whatsapp = JSON.parse(JSON.stringify(whatsapp))
  })
}
export const setToken = (state, token) => {
  state.token = token
}
export const setLiveQuery = (state, query) => {
  state.liveQuery = query
}
export const setVisibility = (state, boolean) => {
  state.dark = boolean
}
export const setProduction = (state) => {
  state.api = state.environment.production
}
export const setHomologation = (state) => {
  state.api = state.environment.homologation
}
export const setDevelopment = (state) => {
  state.api = state.environment.development
}
export const setPermission = (state, permission) => {
  state.permission = permission
}
export const setTags = (state, tags) => {
  state.tags = tags
  let index = ''
  state.tagsOptions = []
  for (index in tags) {
    state.tagsOptions.push({
      label: tags[index].title,
      value: tags[index]._id,
      color: tags[index].color
    })
  }
}
export const setTagsPeople = (state, tags) => {
  let index = ''
  state.tagsOptionsPeople = []
  for (index in tags) {
    state.tagsOptionsPeople.push({
      label: tags[index].title,
      value: tags[index]._id,
      color: tags[index].color
    })
  }
}
export const setTagsCompanies = (state, tags) => {
  let index = ''
  state.tagsOptionsCompanies = []
  for (index in tags) {
    state.tagsOptionsCompanies.push({
      label: tags[index].title,
      value: tags[index]._id,
      color: tags[index].color
    })
  }
}
export const setUsers = (state, users) => {
  // Preserva o status que o socket já tinha entregue para usuários que ainda não estavam na lista,
  // senão a listagem completa sobrescreveria a presença recebida durante o carregamento.
  let userId = ''
  for (userId in state.users) {
    if (users[userId] && users[userId].status === undefined && state.users[userId].status !== undefined) {
      users[userId].status = state.users[userId].status
    }
  }
  state.users = users
  state.usersCount = Object.keys(users).length
  let index = ''
  state.usersOptions = []
  for (index in users) {
    if (users[index].status) {
      state.usersOptions.push({
        label: users[index].n,
        value: users[index]._id.toString()
      })
    }
  }
}

export const updateUserStatus = (state, payload) => {
  const { userId, status } = payload
  if (state.users[userId]) {
    state.users[userId].status = status
  } else {
    state.users[userId] = { status: status }
  }
}

export const setLiveTokens = (state, tokens) => {
  state.live.tokens = tokens
}
export const setLiveTokensOptions = (state, tokensOptions) => {
  state.live.tokensOptions = tokensOptions
}
export const setLiveDepartment = (state, department) => {
  state.live.department = department
}
export const setLiveDepartmentOptions = (state, departmentOptions) => {
  state.live.departmentOptions = departmentOptions
}
export const setLiveSound = (state, sound) => {
  state.live.sound = sound
}
export const setTitle = (state, title) => {
  state.title = title
}
export const setAudio = (state, audio) => {
  if (audio.hasOwnProperty('isRecording')) state.audio.isRecording = audio.isRecording
}
export const setBreadcrumbs = (state, payload) => {
  state.breadcrumbs = {
    title: '',
    help: null,
    paths: [],
    counter: null
  }
  if (payload.title) state.breadcrumbs.title = payload.title
  if (payload.help) state.breadcrumbs.help = payload.help
  if (payload.paths) state.breadcrumbs.paths = payload.paths
}
export const setBreadcrumbCounter = (state, counter) => { state.breadcrumbs.counter = counter }
export const setLiveSoundMessageBell = (state, sound) => {
  state.live.soundMessageBell = sound
}
export const setLiveSoundIsActiveMessageBell = (state, sound) => {
  state.live.soundIsActiveMessageBell = sound
}
export const initialPreferences = (state, data) => {
  state.preferences = data
}
export const setPreferences = async (state, obj) => {
  if (obj.type) {
    switch (obj.type) {
      case 'conversation':
        state.preferences.conversation = obj.payload
        break
      case 'live':
        state.preferences.live = obj.payload
        break
    }
    await axios.post(`${PANEL_URL}/user/update/preferences`, {
      preferences: state.preferences
    })
  }
}
export const setBotsIdentifiers = (state, data) => {
  state.botsIdentifiers[data.token] = data.identifiers
}
export const setLiveStatus = (state, status) => {
  state.liveStatus = status
}
export const setDefault = (state) => {
  try {
    Sentry.setUser(null)
    Sentry.setTag('userId', null)
    Sentry.setTag('accountId', null)
  } catch (e) { /* noop */ }
  state.title = ''
  state.bots = []
  state.botsName = {}
  state.botsId = {}
  state.botsRaw = {}
  state.botsIdentifiers = {}
  state.bot = {}
  state.tags = {}
  state.tagsOptions = []
  state.token = null
  state.userInfo = {}
  state.user = {}
  state.account = {}
  state.socket = null
  state.credits = 0
  state.liveQuery = {
    isMaster: true,
    masterId: null,
    masterName: null,
    masterEmail: null,
    masterRole: null,
    masterAvatar: null,
    tokens: [],
    category: null,
    department: null
  }
  state.live = {
    tokens: null,
    tokensOptions: null,
    department: null,
    departmentOptions: null,
    sound: null,
    soundMessageBell: null,
    soundIsActiveMessageBell: null
  }
  state.liveStatus = 1
  state.preferences = {
    conversation: {},
    live: {}
  }
}
export const disableAlarm = (state) => {
  state.alarm.isActive = false
  state.alarm.tolerance = null
  state.alarm.display = ''
  state.alarm.counter = null
}
export const enableAlarm = (state) => {
  state.alarm.isActive = true
}
export const setToleranceAlarm = (state, payload) => {
  state.alarm.tolerance = payload
}
export const setDisplayAlarm = (state, payload) => {
  state.alarm.display = payload
}
export const setCounterAlarm = (state, payload) => {
  state.alarm.counter = payload
}
export const enableAlarmYellow = (state) => {
  state.alarm.dialogYellow = true
}
export const disableAlarmYellow = (state) => {
  state.alarm.dialogYellow = false
}
export const enableAlarmRed = (state) => {
  state.alarm.dialogRed = true
}
export const disableAlarmRed = (state) => {
  state.alarm.dialogRed = false
}
export const initAdvancedSearch = (state) => {
  state.advancedSearch.match.cdt.$gte = moment().hours(0).minutes(0).seconds(0).milliseconds(0).subtract(6, 'day').format('YYYY-MM-DDTHH:mm:ss.sssZ')
  state.advancedSearch.match.cdt.$lte = moment().hours(23).minutes(59).seconds(59).milliseconds(999).format('YYYY-MM-DDTHH:mm:ss.sssZ')
}

export const removeKnowledgeBaseFilter = (state) => {
  delete state.advancedSearch.match.faqCategory
  delete state.advancedSearch.match.r
}
export const advancedSearchMatch = (state, payload) => {
  if (payload.period || payload.period === null) state.advancedSearch.match.period = payload.period
  if (payload.cdt && payload.cdt.$gte) state.advancedSearch.match.cdt.$gte = payload.cdt.$gte
  if (payload.cdt && payload.cdt.$lte) state.advancedSearch.match.cdt.$lte = payload.cdt.$lte
  if (payload.monetaryValue && (payload.monetaryValue.$gte || payload.monetaryValue.$gte === '' || payload.monetaryValue.$gte === 0)) state.advancedSearch.match.monetaryValue.$gte = payload.monetaryValue.$gte
  if (payload.monetaryValue && (payload.monetaryValue.$lte || payload.monetaryValue.$lte === '' || payload.monetaryValue.$lte === 0)) state.advancedSearch.match.monetaryValue.$lte = payload.monetaryValue.$lte
  if (payload.ih && payload.ih.$in) state.advancedSearch.match.ih.$in = payload.ih.$in
  // Saved filters may still carry the legacy single-string shape.
  if (payload.hb) state.advancedSearch.match.hb = normalizeHbSelection(payload.hb)
  if (payload.tags) state.advancedSearch.match.tags = payload.tags
  if (payload.rating) state.advancedSearch.match.rating = payload.rating
  if (payload.dialogue) state.advancedSearch.match.dialogue = payload.dialogue
  if (payload.live) state.advancedSearch.match.live = payload.live
  if (payload.attendants) state.advancedSearch.match.attendants = payload.attendants
  if (payload.departments) state.advancedSearch.match.departments = payload.departments
  if (payload.cIdentifiers) state.advancedSearch.match.cIdentifiers = payload.cIdentifiers
  if (payload.cIdentifierFill) {
    state.advancedSearch.match.cIdentifierFill = payload.cIdentifierFill
  } else {
    state.advancedSearch.match.cIdentifierFill = false
  }
  if (payload.cResponse || typeof payload.cResponse === 'string') state.advancedSearch.match.cResponse = payload.cResponse
  if (payload.cResponseIdentifiers) state.advancedSearch.match.cResponseIdentifiers = payload.cResponseIdentifiers
  if (payload.cFinished) state.advancedSearch.match.cFinished = payload.cFinished
  if (payload.faqCategory) state.advancedSearch.match.faqCategory = payload.faqCategory
  if (payload.r) state.advancedSearch.match.r = payload.r
  if (payload?.referrals?.source_id) state.advancedSearch.match.referrals = { source_id: payload.referrals.source_id }
  if (payload.hasAttachments) {
    state.advancedSearch.match.hasAttachments = payload.hasAttachments
  } else {
    delete state.advancedSearch.match.hasAttachments;
  }
}
export const advancedSearchMatchCrm = (state, payload) => {
  if (payload.cResponse || typeof payload.cResponse === 'string') state.advancedSearchCrm.match.cResponse = payload.cResponse
  if (payload.tags) state.advancedSearchCrm.match.tags = payload.tags
  if (payload.dynamicFilter) state.advancedSearchCrm.match.dynamicFilter = payload.dynamicFilter
}
export const advancedSearchPeriod = (state, payload) => {
  state.advancedSearch.match.period = payload
}
export const advancedSearchOptions = (state, payload) => {
  if (payload.chatbots) state.advancedSearch.options.chatbots = [{ label: 'Interno', value: null }].concat(payload.chatbots)
  if (payload.identifiers) state.advancedSearch.options.identifiers = payload.identifiers
  if (payload.departments) state.advancedSearch.options.departments = payload.departments
  if (payload.attendants) state.advancedSearch.options.attendants = payload.attendants
}
export const advancedSearchOptionsLang = (state, payload) => {
  state.advancedSearch.options.chatbots.forEach(each => {
    if (each.value === 'all') each.label = AllchatbotsLang[payload.lang]
    if (each.value === null) each.label = internalchatbotsLang[payload.lang]
  })
}
export const advancedSearchGauge = (state, payload) => {
  if (payload.total) state.advancedSearch.gauge.total = payload.total
  if (payload.count) state.advancedSearch.gauge.count = payload.count
  if (payload.average) state.advancedSearch.gauge.average = payload.average
}
export const advancedSearchSetDefault = (state) => {
  state.advancedSearch.match.ih.$in = state.advancedSearch.options.chatbots.map(e => {
    if (e.value) return e.value
  })
  state.advancedSearch.match.hb = []
  state.advancedSearch.match.dialogue = 'Todos'
  state.advancedSearch.match.tags = []
  state.advancedSearch.match.rating = []
  state.advancedSearch.match.live = null
  state.advancedSearch.match.attendants = []
  state.advancedSearch.match.departments = []
  state.advancedSearch.match.cIdentifiers = []
  state.advancedSearch.match.cIdentifierFill = true
  state.advancedSearch.match.cResponse = ''
  state.advancedSearch.match.cResponseIdentifiers = []
  state.advancedSearch.match.cFinished = 'all'
  state.advancedSearch.match.period = 7
  state.advancedSearch.match.monetaryValue.$gte = ''
  state.advancedSearch.match.monetaryValue.$lte = ''
  state.advancedSearch.match.referrals = { source_id: '' }
}

export const advancedSearchCrmSetDefault = (state) => {
  state.advancedSearchCrm.match.cResponse = ''
  state.advancedSearchCrm.match.tags = []
  state.advancedSearchCrm.match.dynamicFilter = [
    {
      field: '',
      condition: '',
      value: ''
    }
  ]
}
export const enableWarningLostConnection = (state) => {
  state.lostConnection.isActive = true
}
export const disableWarningLostConnection = (state) => {
  state.lostConnection.isActive = false
}
export const toggleExpandedTags = (state) => {
  state.expandedTags = !state.expandedTags
}

export const addTemplate = (state, payload) => {
  state.templates.push(payload)
}

export const setTemplates = (state, payload) => {
  state.templates = payload
}

export const updateTemplate = (state, payload) => {
  const index = state.templates.findIndex(template => template._id === payload._id)
  if (index !== -1) {
    state.templates[index] = payload
  }
}

export const removeTemplate = (state, payload) => {
  state.templates = state.templates.filter(template => template._id !== payload._id)
}

export const setKanbanBoards = (state, payload) => {
  state.kanban.boards = payload
}

export const setKanbanColumns = (state, payload) => {
  state.kanban.columns = payload
}

export const updateKanbanColumnsByBoardId = (state, { boardId, columns }) => {
  console.log('updateKanbanColumnsByBoardId', boardId, columns)
  state.kanban.columns[boardId] = columns
}

export const setKanbanCards = (state, payload) => {
  state.kanban.cards = payload
}

export const setKanbanCardsByColumnId = (state, { columnId, cards }) => {
  state.kanban.cards[columnId] = cards
}

export const addKanbanBoard = (state, payload) => {
  if (!state.kanban.boards.find(board => board._id === payload._id)) {
    state.kanban.boards.push(payload)
    state.kanban.columns[payload._id] = []
  }
}

export const updateKanbanBoard = (state, payload) => {
  const index = state.kanban.boards.findIndex(board => board._id === payload._id)
  if (index !== -1) {
    state.kanban.boards[index] = payload
  }
}

export const addKanbanColumn = (state, payload) => {
  if (!state.kanban.columns[payload.kanbanBoardId]) {
    state.kanban.columns[payload.kanbanBoardId] = []
  }
  const columns = state.kanban.columns[payload.kanbanBoardId]
  if (!columns.find(colu => colu._id === payload._id)) {
    columns.push(payload)
    const board = state.kanban.boards.find(board => board._id === payload.kanbanBoardId)
    if (board) {
      if (!board.columns) board.columns = []
      board.columns.push(payload._id)
      updateKanbanBoard(state, board)
    }
  }
}

export const updateKanbanColumn = (state, payload) => {
  if (state.kanban.columns[payload.kanbanBoardId]) {
    const index = state.kanban.columns[payload.kanbanBoardId].findIndex(column => column._id === payload._id)
    if (index !== -1) {
      state.kanban.columns[payload.kanbanBoardId][index] = payload
    }
  }
}

export const addKanbanCard = (state, payload) => {
  if (!state.kanban.cards) {
    state.kanban.cards = {}
  }
  if (!state.kanban.cards[payload.kanbanColumnId]) {
    state.kanban.cards[payload.kanbanColumnId] = []
  }
  const cards = state.kanban.cards[payload.kanbanColumnId]
  if (!cards.find(card => card._id === payload._id)) {
    cards.push(payload)
    if (!state.kanban.columns[payload.kanbanBoardId]) {
      state.kanban.columns[payload.kanbanBoardId] = []
    }
    const column = state.kanban.columns[payload.kanbanBoardId].find(
      column => column._id === payload.kanbanColumnId,
    )
    if (column) {
      if (!column.cards) column.cards = []
      column.cards.push(payload._id)
    }
  }
}

export const updateKanbanColumnPosition = (state, { boardId, columnId, newPosition }) => {
  console.log('updateKanbanColumnPosition', state.kanban)
  const board = state.kanban.boards.find(board => board._id === boardId)
  if (board) {
    board.columns = Utils.moveStringInArray(board.columns, columnId, newPosition);
    updateKanbanBoard(state, board)
    // Reorganize the columns array based on the new order
    const orderedColumns = board.columns
      .map(colId => state.kanban.columns[boardId].find(col => col._id === colId))
      .filter(col => col !== undefined)
    state.kanban.columns[boardId] = orderedColumns
  }
}

export const removeKanbanBoard = (state, payload) => {
  const index = state.kanban.boards.findIndex(board => board._id === payload._id)
  if (index !== -1) {
    // Remove todas as colunas relacionadas ao board
    const board = state.kanban.boards[index]
    if (board.columns && Array.isArray(board.columns)) {
      state.kanban.columns[board._id] = []
    }
    // Remove o board
    state.kanban.boards.splice(index, 1)
  }
}

export const removeKanbanColumn = (state, { boardId, columnId }) => {
  const index = state.kanban.columns[boardId].findIndex(column => column._id === columnId)
  if (index !== -1) {
    state.kanban.columns[boardId].splice(index, 1)
    const board = state.kanban.boards.find(board => board._id === boardId)
    if (board) {
      const indexColumnInBoard = board.columns.findIndex(col => col === columnId)
      if (indexColumnInBoard !== -1) {
        board.columns.splice(indexColumnInBoard, 1)
        updateKanbanBoard(state, board)
      }
    }
  }
}
export const setPhoneCountries = (state, payload) => {
  state.phoneCountries = payload
}

export const updateBotIt = (state, payload) => {
  state.bots = state.bots.map(bot => {
    if (bot._id === payload._id) {
      return {
        ...bot,
        it: payload.it
      }
    }
    return bot
  })
}